import { AcademicLevel, Email, FirstName, LastName, MobilePhoneRequired, Salutation, Section, Specialites, Consentement } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  campus: Yup.array().min(1, "Vous devez choisir au minimum un campus"),
  consent: Yup.object().shape({
    ...Consentement
  }),
  formations: Yup.array().min(1, 'Vous devez choisir au minimum un programme'),
  lead: Yup.object().shape({
    ...AcademicLevel,
    // ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    ...Salutation,
    ...Section,
  }),
  ...Specialites
})

export default schema
